import { Reveal, SectionHead } from "@/components/Reveal";
import { ThermalSlider } from "@/components/ThermalSlider";

export const DemoSection = () => (
  <section className="py-24 md:py-36" data-testid="demo-section">
    <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-10">
      <SectionHead nr="03" overline="Interactieve demonstratie" title="Bekijk wat een normale camera niet laat zien" />
      <Reveal delay={0.15} className="mt-12">
        <ThermalSlider />
      </Reveal>
    </div>
  </section>
);
